<template>
  <div
    v-if="show"
    class="fixed inset-0 bg-gray-900 bg-opacity-60 overflow-y-hidden h-full w-full flex items-center justify-center text-base"
  >
    <div
      v-if="showLoader"
      class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
    >
      <div
        class="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-yellow-500"
      ></div>
    </div>
    <div
      v-else
      class="bg-white rounded-lg shadow-xl w-9/12 h-[70vh] overflow-hidden"
    >
      <div class="flex items-center justify-between p-4 border-b">
        <h2 class="text-2xl text-gray-800 font-semibold">Pharmacy</h2>
        <button
          @click="closeModal"
          class="text-gray-500 hover:text-gray-700"
          aria-label="Close"
        >
          <svg
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
      </div>

      <div class="p-6 flex max-h-[85vh] overflow-y-auto">
        <!-- Left column -->
        <div class="w-2/12 pr-6 border-r">
          <div class="flex items-center mb-4">
            <img
              src="@/assets/images/avatar.png"
              alt="Patient"
              class="w-12 h-12 rounded-full mr-4"
            />
            <div>
              <h3 class="font-semibold">
                {{ prescriptionDetails?.patient?.FullName }}
              </h3>
              <p class="text-sm text-gray-600">
                Visit Code: {{ prescriptionDetails.VisitCode }}
              </p>
            </div>
          </div>

          <div class="space-y-2 mb-6">
              <p>
              <span class="font-semibold">Patient Unique Code:</span>
              {{ prescriptionDetails?.patient?.unique_code }}
            </p>
            <p>
              <span class="font-semibold">Email:</span>
              {{ prescriptionDetails?.patient?.EmailAddress || "N/A" }}
            </p>
            <p>
              <span class="font-semibold">Phone:</span>
              {{ prescriptionDetails?.patient?.PhoneNumber || "N/A" }}
            </p>
            <p>
              <span class="font-semibold">D.O.B:</span>
              {{ prescriptionDetails?.patient?.Dob }}
            </p>
            <p>
              <span class="font-semibold">Gender:</span>
              {{ prescriptionDetails?.patient?.Gender }}
            </p>
            <p>
              <span class="font-semibold">Next of Kin:</span>
              {{ prescriptionDetails?.patient?.emergency_contact?.Name || "N/A" }}
            </p>
            <p>
              <span class="font-semibold">Phone:</span>
              {{ prescriptionDetails?.patient?.emergency_contact?.PhoneNumber || "N/A" }}
            </p>
          </div>
        </div>

        <!-- Right column -->
        <div class="w-10/12 pl-6">
          <!-- Tabs -->
          <div class="mb-4 border-b">
            <ul class="flex flex-wrap -mb-px">
              <li v-for="tab in tabs" :key="tab.name" class="mr-2">
                <a
                  href="#"
                  @click.prevent="currentTab = tab.component"
                  :class="[
                    'inline-block p-4 rounded-t-lg',
                    currentTab === tab.component
                      ? 'border-b-2 border-custom-yellow text-custom-blue'
                      : 'hover:text-gray-600 hover:border-gray-300',
                  ]"
                >
                  {{ tab.name }}
                </a>
              </li>
            </ul>
          </div>

          <!-- Tab content -->
          <component
            :is="currentTab"
            :prescriptionDetails="prescriptionDetails"
            @refetch="fetchPrescriptionDetails(false)"
            @fetch-prescriptions="reFetchPrescriptions"
            @close="closeModal"
            @next="goToNextTab()"
          ></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PrescriptionDetailsTab from "@/views/tabs/pharmacy_tabs/PrescriptionDetailsTab.vue";
import AllocatePrescriptionTab from "@/views/tabs/pharmacy_tabs/AllocatePrescriptionTab.vue";
import apiClient from "@/services/api";

export default {
  name: "PharmacyQueueModal",
  components: {
    PrescriptionDetailsTab,
    AllocatePrescriptionTab,
  },
  props: {
    show: Boolean,
    prescriptionId: { type: String, required: true },
  },
  data() {
    return {
      tabs: [
        { name: "Prescription Details", component: "PrescriptionDetailsTab" },
        { name: "Issue Prescription", component: "AllocatePrescriptionTab" },
      ],
      currentTab: "PrescriptionDetailsTab",
      prescriptionDetails: {},
      showLoader: false,
      currentTabIndex: 0,
    };
  },
  watch: {
    prescriptionId(newValue) {
      if (newValue) {
        this.fetchPrescriptionDetails(true);
      }
    },
  },
  methods: {
    reFetchPrescriptions() {
      this.$emit("refetch");
    },
    closeModal() {
      this.$emit("close");
    },
    goToNextTab() {
      if (this.currentTabIndex < this.tabs.length - 1) {
        this.currentTabIndex++;
        this.currentTab = this.tabs[this.currentTabIndex]?.component;
      }
    },

    // Function to go back to the previous tab
    goToPreviousTab() {
      if (this.currentTabIndex > 0) {
        this.currentTabIndex--;
        this.currentTab = this.tabs[this.currentTabIndex]?.component;
      }
    },
    async fetchPrescriptionDetails(show) {
      try {
        if (show) {
          this.showLoader = true;
        }

        const response = await apiClient.fetchPatientPrescriptionDetails(
          this.prescriptionId
        );
        if (response.success) {
          if (show) {
            this.showLoader = false;
          }
          this.prescriptionDetails = response.data;
        } else {
          this.$toast.error("Failed to fetch prescription details.");
        }
      } catch (error) {
        if (show) {
          this.showLoader = false;
        }
        this.$toast.error("Failed to fetch prescription details.");
      }
    },
  },
};
</script>
